module.exports = __webpack_public_path__ + "static/media/contact-slide-1.c4638253.jpg";